import { render, staticRenderFns } from "./IndexSearch.vue?vue&type=template&id=1535cfe4"
import script from "./IndexSearch.vue?vue&type=script&lang=js"
export * from "./IndexSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports